import React, { useEffect, useState } from 'react';
import Select from '../../Select';
const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
const MonthDropdown = ({ currentMonth, changeMonth, }) => {
    const options = months.map(m => ({ name: m, value: m }));
    const [selectedOption, setSelectedOption] = useState(options[currentMonth].value);
    const handlechange = (option) => {
        changeMonth(months.indexOf(option.value));
        setSelectedOption(option.value);
    };
    const managefocus = () => {
        const selectedDaySelector = 'div[tabindex="0"]';
        const calendar = document.getElementsByClassName("react-datepicker-popper");
        const focusableElement = calendar[0].querySelectorAll('button');
        const selectedDay = calendar[0].querySelector(selectedDaySelector);
        if (selectedDay) {
            selectedDay.focus();
        }
        else {
            focusableElement.forEach((element) => {
                if (element.disabled === false) {
                    element.style.backgroundColor = "#f0f0f0";
                    element.focus();
                }
            });
        }
    };
    useEffect(() => {
        setSelectedOption(options[currentMonth].value);
        managefocus();
    }, [options, currentMonth]);
    return (React.createElement(Select, { defaultOption: false, height: 2, width: 6, label: `Choose Month, ${selectedOption}`, onChange: (option) => handlechange(option), options: options, selectedOption: options[currentMonth] }));
};
export default MonthDropdown;
